import { RESET_BEHAVE_AS, SET_BEHAVE_AS } from "./appConstants";

export const setBehaveAs = (email) => ({
  type: SET_BEHAVE_AS,
  email,
});

export const resetBehaveAs = () => ({
  type: RESET_BEHAVE_AS,
});
